module.exports = __webpack_public_path__ + "media/images/face_size_image-e66e7d18.png";